import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import NewEmployee from '@/components/Employee/NewEmployee'
import ViewEmployee from '@/components/Employee/ViewEmployee'
import EditEmployee from '@/components/Employee/EditEmployee'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/new',
      name: 'New-Employee',
      component: NewEmployee
    },
    {
      path: '/:employeeId',
      name: 'View-Employee',
      component: ViewEmployee
    },
    {
      path: '/edit/:employeeId',
      name: 'Edit-Employee',
      component: EditEmployee
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js